import LayoutAuthenticated from "@/src/containers/Layouts/LayoutAuthenticated";
import HintBox from "../../../Box/HintBox/HintBox";
import React from "react";
import { getCaseLink, getProductData, getProductNameBy } from "@/src/services/productService";
import Button from "@mui/material/Button";
import { Link, useLocation } from "react-router";
import useProductParams from "../../../../hooks/useProductParams";
import { useQuery } from "@tanstack/react-query";
import { fetchResource, queryKeys } from "@/src/services/reactQuery/reactQueryService";
import LegalbirdLoader from "../../../ContentLoader/LegalbirdLoader";
import { Typography } from "@mui/material";

const FlexServiceFeedbackConfirm = () => {
  const { productName, productId } = useProductParams();
  const productClassName = getProductNameBy("urlPartShort", productName);
  const productApiUri = getProductData(productClassName, "apiUri");
  const { data: product, isLoading: isLoadingProduct } = useQuery({
    queryKey: queryKeys.item(productApiUri, productId),
    queryFn: () => fetchResource(productApiUri, productId)
  });
  const { state } = useLocation();

  if (isLoadingProduct) {
    return (
      <LayoutAuthenticated>
        <LegalbirdLoader />
      </LayoutAuthenticated>
    );
  }

  if (state !== "sendForm") {
    return (
      <LayoutAuthenticated>
        <HintBox headline={"Keine Berechtigung"}>
          Sie haben aktuell nicht die Berechtigung diese Seite aufzurufen.
          <Button component={Link} to={getCaseLink(product)} variant={"text"} color={"primary"}>
            Zurück zum Fall
          </Button>
        </HintBox>
      </LayoutAuthenticated>
    );
  }

  return (
    <LayoutAuthenticated>
      <HintBox headline={"Vielen Dank für Ihre Rückmeldung!"}>
        {!!product.finalClaimStatusClient ? (
          <Typography>Wir haben Ihre Rückmeldung erhalten. Vielen Dank für die Nutzung unseres Services</Typography>
        ) : (
          <Typography>
            Damit wir weiter für Sie tätig werden können, müssen Sie bitte zunächst in der Servicewelt weitere Angaben zu Ihrem Fall ergänzen und uns die
            Vollmacht erteilen. Keine Sorge: Ihre bisherigen Angaben und Dokumente sind nach wie vor vorhanden. Sie können diese also gerne weiter benutzen
            oder gegebenenfalls um neue Informationen ergänzen.
          </Typography>
        )}
        <Button component={Link} to={getCaseLink(product) + (!!product.finalClaimStatusClient ? "" : "/antrag")} variant={"text"} color={"primary"}>
          Zurück zum Fall
        </Button>
      </HintBox>
    </LayoutAuthenticated>
  );
};
export default FlexServiceFeedbackConfirm;
